export default theme => ({
  listingNotFoundPaper: {
    display: "flex",
    height: "100%",
    padding: theme.spacing(2)
  }
});
